// @generated
import { PapiDeviation } from '@wix/da-papi-types';

export const originalDeviations: PapiDeviation[] = [
  {
    deviationId: 1315459641,
    type: 'originals',
    typeId: 93,
    url: 'https://www.deviantart.com/rgsvisualworks/art/Cinematic-Clips-Basic-NewTechnology-1315459641',
    shortUrl: 'http://fav.me/dlr6v5l',
    title: 'Cinematic Clips Basic | #NewTechnology',
    isJournal: false,
    isVideo: false,
    isPurchasable: false,
    isAdoptable: false,
    isFavouritable: true,
    publishedTime: '2026-03-29T17:35:22-0700',
    isTextEditable: false,
    isBackgroundEditable: false,
    legacyTextEditUrl: null,
    isShareable: true,
    isCommentable: true,
    isFavourited: false,
    isDeleted: false,
    isMature: false,
    isNsfg: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    isDailyDeviation: false,
    hasPrivateComments: false,
    isDreamsofart: false,
    isUpscaled: false,
    isAiUseDisallowed: true,
    isAiGenerated: true,
    canUpdateAiClaim: true,
    isMultiImage: false,
    isMultiMedia: false,
    canBeMultiImage: true,
    canBeMultiMedia: true,
    isDefaultImage: false,
    isOriginalsDelivery: false,
    license: 'none',
    blockReasons: [],
    author: {
      userId: 112913903,
      useridUuid: '2179a3b0-c900-4d4b-af7e-9e251ba4183f',
      username: 'RGSVisualWorks',
      usericon: 'https://a.deviantart.net/avatars-big/r/g/rgsvisualworks.jpg?12',
      type: 'core_pro',
      isGroup: false,
      isWatching: false,
      isSubscribed: false,
      isNewDeviant: false,
    },
    stats: {
      comments: 0,
      favourites: 0,
      views: 1088,
      downloads: 0,
      privatelyCollected: 0,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/2179a3b0-c900-4d4b-af7e-9e251ba4183f/dlr6v5l-1b3cfc80-ab48-4c67-bfdd-81830f0e34e5.png',
      prettyName: 'cinematic_clips_basic____newtechnology_by_rgsvisualworks_dlr6v5l',
      token: [
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTIzOSIsInBhdGgiOiIvZi8yMTc5YTNiMC1jOTAwLTRkNGItYWY3ZS05ZTI1MWJhNDE4M2YvZGxyNnY1bC0xYjNjZmM4MC1hYjQ4LTRjNjctYmZkZC04MTgzMGYwZTM0ZTUucG5nIiwid2lkdGgiOiI8PTI1MjgifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.X7Y6ZzbY5v5L4j8-nnt79p8dD6VKFGYwlTmKc1o_TAA',
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiIvZi8yMTc5YTNiMC1jOTAwLTRkNGItYWY3ZS05ZTI1MWJhNDE4M2YvZGxyNnY1bC0xYjNjZmM4MC1hYjQ4LTRjNjctYmZkZC04MTgzMGYwZTM0ZTUucG5nIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.awiP_N5uUBouVzS358kYt_MeJqKk6kUHgOY0g24FUfc',
      ],
      types: [
        {
          t: '150',
          r: 0,
          c: '/v1/fit/w_150,h_150,q_70,strp/<prettyName>-150.jpg',
          h: 74,
          w: 150,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_300,h_300,q_70,strp/<prettyName>-150-2x.jpg',
              w: 300,
              h: 300,
            },
          ],
        },
        {
          t: '200H',
          r: 0,
          c: '/v1/fill/w_300,h_147,q_70,strp/<prettyName>-200h.jpg',
          h: 147,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_600,h_294,q_70,strp/<prettyName>-200h-2x.jpg',
              w: 600,
              h: 294,
            },
          ],
        },
        {
          t: '300W',
          r: 0,
          c: '/v1/fit/w_300,h_900,q_70,strp/<prettyName>-300w.jpg',
          h: 147,
          w: 300,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_600,h_1239,q_70,strp/<prettyName>-300w-2x.jpg',
              w: 600,
              h: 1239,
            },
          ],
        },
        {
          t: '375W',
          r: 0,
          c: '/v1/fit/w_375,h_184,q_70,strp/<prettyName>-375w.jpg',
          h: 184,
          w: 375,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_750,h_368,q_70,strp/<prettyName>-375w-2x.jpg',
              w: 750,
              h: 368,
            },
          ],
        },
        {
          t: '414W',
          r: 0,
          c: '/v1/fit/w_414,h_203,q_70,strp/<prettyName>-414w.jpg',
          h: 203,
          w: 414,
          ss: [
            {
              x: 2,
              c: '/v1/fit/w_828,h_406,q_70,strp/<prettyName>-414w-2x.jpg',
              w: 828,
              h: 406,
            },
          ],
        },
        {
          t: '250T',
          r: 0,
          c: '/v1/fill/w_500,h_245,q_70,strp/<prettyName>-250t.jpg',
          h: 245,
          w: 500,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1000,h_490,q_70,strp/<prettyName>-250t-2x.jpg',
              w: 1000,
              h: 490,
            },
          ],
        },
        {
          t: '350T',
          r: 0,
          c: '/v1/fill/w_700,h_343,q_70,strp/<prettyName>-350t.jpg',
          h: 343,
          w: 700,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1400,h_686,q_70,strp/<prettyName>-350t-2x.jpg',
              w: 1400,
              h: 686,
            },
          ],
        },
        {
          t: '400T',
          r: 0,
          c: '/v1/fill/w_800,h_392,q_70,strp/<prettyName>-400t.jpg',
          h: 392,
          w: 800,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1600,h_784,q_70,strp/<prettyName>-400t-2x.jpg',
              w: 1600,
              h: 784,
            },
          ],
        },
        {
          t: 'preview',
          r: 0,
          c: '/v1/fill/w_1277,h_626,q_70,strp/<prettyName>-pre.jpg',
          h: 626,
          w: 1277,
          f: 4311450,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1277,h_626,q_70,strp/<prettyName>-pre-2x.jpg',
              w: 1277,
              h: 626,
            },
          ],
        },
        {
          t: 'social_preview',
          r: 0,
          c: '/v1/fill/w_1277,h_626,q_70,strp/<prettyName>-pre.jpg',
          h: 626,
          w: 1277,
          ss: [
            {
              x: 2,
              c: '/v1/fill/w_1277,h_626,q_70,strp/<prettyName>-pre-2x.jpg',
              w: 1277,
              h: 626,
            },
          ],
        },
        {
          t: 'fullview',
          r: 1,
          h: 1239,
          w: 2528,
          f: 4311450,
        },
        {
          t: '92S',
          r: 0,
          c: '/v1/crop/w_92,h_92,x_24,y_0,scl_0.074253430185634,q_70,strp/<prettyName>-92s.jpg',
          h: 92,
          w: 92,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_184,h_184,x_48,y_0,scl_0.14850686037127,q_70,strp/<prettyName>-92s-2x.jpg',
              w: 184,
              h: 184,
            },
          ],
        },
        {
          t: '125S',
          r: 0,
          c: '/v1/crop/w_125,h_125,x_33,y_0,scl_0.10088781275222,q_70,strp/<prettyName>-125s.jpg',
          h: 125,
          w: 125,
          ss: [
            {
              x: 2,
              c: '/v1/crop/w_250,h_250,x_65,y_0,scl_0.20177562550444,q_70,strp/<prettyName>-125s-2x.jpg',
              w: 250,
              h: 250,
            },
          ],
        },
      ],
    },
    filetype: 'png',
  },
];
